import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Moon } from "@phosphor-icons/react";
import { API } from "../context/AuthContext";
import axios from "axios";

const SIGN_GLYPH = {
    Aries: "♈", Taurus: "♉", Gemini: "♊", Cancer: "♋", Leo: "♌", Virgo: "♍",
    Libra: "♎", Scorpio: "♏", Sagittarius: "♐", Capricorn: "♑", Aquarius: "♒", Pisces: "♓",
};

export default function MoonWidget() {
    const [moon, setMoon] = useState(null);

    useEffect(() => {
        axios.get(`${API}/moon-phase`).then((r) => setMoon(r.data)).catch(() => {});
    }, []);

    if (!moon) return null;

    // SVG moon face illuminated by current phase
    const illum = moon.illumination_percent / 100;
    const waxing = moon.phase < 0.5;

    return (
        <motion.section
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="glass p-5 flex items-center gap-4"
            data-testid="moon-widget"
        >
            <div className="w-14 h-14 flex-shrink-0 relative">
                <svg viewBox="0 0 100 100" className="w-full h-full">
                    <defs>
                        <clipPath id="moon-circ"><circle cx="50" cy="50" r="45" /></clipPath>
                    </defs>
                    <circle cx="50" cy="50" r="45" fill="#1a1a2e" stroke="rgba(230,195,135,0.4)" strokeWidth="1" />
                    <g clipPath="url(#moon-circ)">
                        {/* Illumination via elliptical mask */}
                        <ellipse
                            cx="50"
                            cy="50"
                            rx={45 * Math.abs(1 - 2 * illum)}
                            ry="45"
                            fill={waxing ? "#1a1a2e" : "#E6C387"}
                        />
                        <rect
                            x={waxing ? 50 : 5}
                            y="5"
                            width="45"
                            height="90"
                            fill={waxing ? "#E6C387" : "#1a1a2e"}
                        />
                        {illum > 0.5 && waxing && (
                            <ellipse cx="50" cy="50" rx={45 * (2 * illum - 1)} ry="45" fill="#E6C387" />
                        )}
                        {illum > 0.5 && !waxing && (
                            <ellipse cx="50" cy="50" rx={45 * (2 * illum - 1)} ry="45" fill="#E6C387" />
                        )}
                    </g>
                </svg>
            </div>
            <div className="flex-1 min-w-0">
                <p className="label-tracking text-gold flex items-center gap-1.5">
                    <Moon size={12} weight="duotone" /> Today's Moon
                </p>
                <p className="font-serif text-lg mt-0.5 truncate">
                    {moon.phase_name}
                    <span className="text-muted text-sm ml-2">{moon.illumination_percent}% lit</span>
                </p>
                <p className="text-xs text-muted mt-0.5">
                    Moon in {SIGN_GLYPH[moon.moon_sign]} <span className="text-gold">{moon.moon_sign}</span>
                </p>
            </div>
        </motion.section>
    );
}
